import { render, staticRenderFns } from "./classification-list-combobox.vue?vue&type=template&id=55c0e5de&"
import script from "./classification-list-combobox.vue?vue&type=script&lang=js&"
export * from "./classification-list-combobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports